import React from "react";
import { byAPrefix, byCodes, getPostNum } from "../../../../constant/General";


const RenderPosA = ({
    posts,
    left = "35px",
    mr = "19px",
    top = "95px",
    field = "twoD",
    width = "140px",
    fontSize = "90px",
    right,
    bottom
}) => {
    return <div style={{
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        fontSize: fontSize
    }} className="position-absolute d-flex post-tc">
        {posts.map((post, i) => {
            return <div
                style={{
                    height: "95px", marginTop: "19px"
                }}
                className="d-flex" key={i}>
                <div className="fw-bold d-flex justify-content-center" style={{
                    marginRight: mr, width: width
                }}>{getPostNum(post[field])}</div>
            </div>
        })}
    </div>
}


function ResultTable({ result }) {
    const post = {
        postBCD: byCodes(result.rightResults, ["B", "C", "D"]),
        postA3D: byAPrefix(result.rightResults, 3),
        postA2D: byAPrefix(result.rightResults, 4),
    };
    return (<div className="w-50 d-flex overflow-hidden justify-content-center align-items-center position-relative">
        <div className="w-100 h-100 position-relative">

            <RenderPosA mr="14px"
                fontSize="85px"
                width="165px"
                top="10px"
                left="200px"
                posts={post.postA3D}
                field="threeD" />

            <RenderPosA
                top="130px"
                left="10px"
                width="170px"
                posts={post.postA2D} />

            <div style={{
                bottom: "25px", left: "255px",
                fontSize: "100px"
            }} className="post-tc position-absolute fw-bold">
                {post.postBCD.map((post, i) => {
                    return <div
                        style={{
                            height: "100px", marginTop: "28px"
                        }}
                        className="d-flex" key={i}>
                        <div style={{
                            marginRight: "105px", width: "150px"
                        }}>{getPostNum(post.twoD)}</div>
                        <div>{getPostNum(post.threeD)}</div>
                    </div>
                })}
            </div>
        </div>
    </div>);
}

export default ResultTable;